import Vue from 'vue';
import VueScreen from 'vue-screen';
import tailwindConfig from '~/tailwind.config.js';

Vue.use(VueScreen, tailwindConfig.theme.screens);
